import CategoryList from 'components/categoryList/typeAd';
import Header from 'modules/header/wholesaler/main';
const AddAdsPage = () => {
  return (
    <>
      <Header title="ثبت آگهی" />
      <CategoryList
        title="نوع آگهی را انتخاب کنید"
        route="/wholesaler/add-ad/type-ads"
        appType="wholesaler"
      />
    </>
  );
};

export default AddAdsPage;
